import instance from './instance';

export const API_BASE_URL = `${process.env.REACT_APP_S3}`;

export const fetchFaq = async () => {
  const response = await instance.get(API_BASE_URL);
  return response.data;
};